import * as angular from 'angular';
import { EventService } from '@go-modules/services/event/event.service';
import { EVENT_NAMES } from '@go-modules/services/event/event-names.constants';

export class RubricCheckboxController {

	public element: any;
	public isChecked: boolean;
	public checkboxId: string;

	/* @ngInject */
	constructor (
		private $scope: any,
		private eventService: EventService,
		private $translate: angular.translate.ITranslateService
	) {}

	public $onInit () {
		this.element = this.$scope.element;
		this.isChecked = this.setChecked();
		this.checkboxId = 'rb-checkbox-input-' + this.element.id;
	}

	/**
	 * Handles input change event
	 */
	public onInputChange () {
		if (this.isChecked) {
			if (this.element.value == null || this.element.value === '') {
				this.element.points = 0;
			} else {
				this.element.points = parseFloat(this.element.value);
			}
		} else {
			this.element.points = null;
		}

		// emit change event
		this.eventService.broadcast(EVENT_NAMES.RUBRIC_DATA_CHANGE);
	}

	public getCheckboxAriaIndex (): number | null {
		const checkboxIndex = (this.$scope.schema?.elements || [])
			.filter((item) => item.type === 'checkbox')
			.indexOf(this.element);

		return checkboxIndex >= 0 ? checkboxIndex + 1 : null;
	}

	public getCheckboxLabelAriaLabel (): string {
		const checkboxIndex = this.getCheckboxAriaIndex();
		const label = this.element.label || this.$translate.instant('rubric_aria-checkbox-label');
		return checkboxIndex != null ? `${label} ${checkboxIndex}` : label;
	}

	public getCheckboxDescriptionAriaLabel (): string {
		const checkboxIndex = this.getCheckboxAriaIndex();
		const label = this.element.desc || this.$translate.instant('rubric_aria-checkbox-description');
		return checkboxIndex != null ? `${label} ${checkboxIndex}` : label;
	}

	public getCheckboxContextLabel (): string {
		const checkboxIndex = this.getCheckboxAriaIndex();
		const label = this.element.label || this.$translate.instant('rubric_aria-checkbox-item');
		return checkboxIndex != null ? `${label} ${checkboxIndex}` : label;
	}

	public getCheckboxElementAriaLabel (): string {
		return this.$translate.instant('rubric_aria-checkbox-for', {context: this.getCheckboxContextLabel()});
	}

	public getCheckboxPointsAriaLabel (): string {
		return this.$translate.instant('rubric_aria-points-for', {context: this.getCheckboxContextLabel()});
	}

	private setChecked (): boolean {
		return !isNaN(parseFloat(this.element.points));
	}
}
